<template>
  <div class="c-navigation-bar hairlines" :style="rootStyles">
    <div class="c-navigation-bar-wrap" ref="wrap" :style="[wrapStyles]">
      <div class="c-navigation-bar-back" :style="backStyles" @click="handleBack">
        <slot name="left" :opacity="backgroundOpacity"><i class="iconfont-front icon-back"></i></slot>
      </div>
      <div class="c-navigation-bar-title ellipsis" :class="{ showRight: !!$slots.right }" :style="titleStyles">
        <slot name="title">{{ title }}</slot>
      </div>
      <div class="c-navigation-bar-right" :style="rightStyles"><slot name="right"></slot></div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    mode: {
      type: String,
      default: 'default', // default/transparent/opacity
    },
    title: {
      type: String,
      default: '',
    },
    backgroundColor: {
      type: String,
      default: '#ffffff',
    },
    onBack: {
      type: Function, // 等待执行完onBack再回退
    },
    border: {
      type: Boolean,
      default: true, // 下边框是否显示
    },
  },
  components: {},
  data() {
    return { scrollY: 0, scrollHeight: 150 };
  },
  computed: {
    // isApp() {
    //   return true;
    // },
    minHeight() {
      if ((this.isApp && this.mode === 'default') || this.$slots.right) {
        return '44px';
      }
      return '0px';
    },
    // alpha() {
    //   const { mode, scrollY } = this;
    //   if (mode === 'default') {
    //     return 1;
    //   }
    //   const opacity = (scrollY > this.scrollHeight ? this.scrollHeight : scrollY) / this.scrollHeight;
    //   if (scrollY < 10) return opacity;
    //   return opacity < 0.5 ? 0.5 : opacity;
    // },

    backgroundOpacity() {
      const { mode, scrollY, scrollHeight } = this;
      if (mode === 'default') {
        return 1;
      }
      if (mode === 'transparent') {
        return 0;
      }
      return (scrollY > scrollHeight ? scrollHeight : scrollY) / scrollHeight;
    },
    rootStyles() {
      const display = this.$slots.right || this.isApp ? 'block' : 'none';
      const statusBarHeight = window.zeeho.statusBarHeight() || 0;
      const minHeight = this.mode !== 'transparent' && this.backgroundOpacity !== 0 ? `calc(${window.zeeho.statusBarHeight()} + ${this.minHeight})` : 0;
      console.log('statusBarHeight 高度: ' + statusBarHeight);
      console.log('minHeight:' + minHeight);
      console.log(`display:${display}; min-height:${minHeight};`);
      return { display, minHeight };
    },
    wrapStyles() {
      const paddingTop = window.zeeho.statusBarHeight() || 0;
      const minHeight = this.mode !== 'transparent' && this.backgroundOpacity !== 0 ? `calc(${window.zeeho.statusBarHeight()} + ${this.minHeight})` : 0;
      if (this.mode === 'default') {
        return { minHeight, paddingTop, backgroundColor: this.backgroundColor };
      }
      const borderBottom = this.border && this.isApp && this.backgroundOpacity > 0.5 ? `1px solid rgba(244, 245, 247, ${this.backgroundOpacity})` : 'none';
      const backgroundColor = this.mode === 'transparent' ? `rgba(255,255,255,${0})` : `rgba(255,255,255,${this.backgroundOpacity})`;

      return { minHeight, paddingTop, borderBottom, backgroundColor };
    },

    backStyles() {
      if (!this.isApp) {
        return { opacity: 0 };
      }
      if (this.mode === 'default') {
        return { color: this.backgroundColor === '#ffffff' ? '#001A21' : '#ffffff' };
      }
      const color = this.backgroundOpacity < 0.5 ? '#ffffff' : '#001A21';
      const opacity = this.isApp ? 1 : 0; //app环境
      return { opacity, color };
    },
    titleStyles() {
      if (this.mode === 'default') {
        return { color: '#001A21' };
      }
      const color = this.backgroundOpacity < 0.5 ? 'rgba(255,255,255,0)' : '#001A21';
      const opacity = !this.isApp ? 0 : 1; //非app环境||自定义背景色
      return { color, opacity };
    },
    rightStyles() {
      const color = this.backgroundOpacity < 0.5 ? '#ffffff' : '#001A21';
      const display = this.$slots.right ? 'block' : 'none'; //如果right插槽存在内容
      return { display, color };
    },
  },
  methods: {
    async handleBack() {
      try {
        console.log(window.zeeho);
        console.log('executeNativeFunction navigateBack:', window.zeeho.existFunction('navigateBack'));
        if (this.onBack) {
          await this.onBack();
        }
        this.$router.back();
      } catch (error) {
        throw new Error(error);
      }
    },
    onPageScroll(e) {
      this.scrollY = e.target.scrollTop;
      // this.scrollY = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset || 0;
    },
  },
  created() {},
  mounted() {
    const div = document.createElement('div');
    div.style.width = '1px';
    div.style.height = 'env(safe-area-inset-top)';
    setTimeout(() => {
      console.log('statusBarHeight 高度 mounted: ' + div.offsetHeight + 'px');
      console.log(`height:${this.$refs.wrap.offsetHeight}`);
    }, 0);
  },
  beforeUnmount() {},
  watch: {
    wrapStyles: {
      deep: true,
      handler() {
        this.$nextTick(() => {
          console.log(`height:${this.$refs.wrap.offsetHeight}`);
        });
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.c-navigation-bar.hairlines {
  position: relative;
  min-height: calc(constant(safe-area-inset-top) + 44px);
  min-height: calc(env(safe-area-inset-top) + 44px);
  box-sizing: content-box;
  .c-navigation-bar {
    padding: 0;
    &-wrap {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      position: fixed;
      box-sizing: border-box;
      padding: 0 15px;
      top: 0;
      left: var(--viewport-left);
      right: var(--viewport-right);
      max-width: 100vw;
      z-index: 1100;
      min-height: calc(constant(safe-area-inset-top) + 44px);
      min-height: calc(env(safe-area-inset-top) + 44px);
      padding-top: constant(safe-area-inset-top);
      padding-top: env(safe-area-inset-top);
      background-color: #ffffff;
    }
    &-back {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      width: 44px;
      height: 44px;
      line-height: 1;
      .icon-back {
        position: relative;
        left: -14px;
        transform-origin: 50% 50%;
        transform: rotate(180deg);
        font-size: 18px;
      }
    }
    &-title {
      font-family: PingFangSC, PingFang SC;
      display: block;
      position: absolute;
      left: 50%;
      min-width: 0;
      height: 44px;
      line-height: 44px;
      // display: flex;
      line-height: 44px;
      flex-direction: row;
      justify-content: center;
      transform: translateX(-50%);
      color: #001a21;
      font-weight: 500;
      font-size: 19px;
      white-space: nowrap;
      margin-left: 10px;
      max-width: calc(100% - 88px);
      &.showRight {
        margin-left: 0;
        max-width: calc(100% - 118px);
      }
    }
    &-right {
      min-width: 44px;
      color: #001a21;
      font-weight: 400;
      font-size: 14px;
      .btn-primary {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        padding: 0;
        border: none;
        background-color: transparent;
        height: 44px;
        font-size: 14px;
        font-weight: 500;
        color: #00c5d1;
      }
    }
  }
}
</style>
